<template>
  <div class="mt-component-form print-container">
    <vs-row  v-if="isShowTitle" class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> {{title}}
        </h5>
      </vs-col>
    </vs-row>

    <!-- PC 레이아웃 -->
    <div class="pc-layout mt-4" :class="onlyPc ? ['block'] : ['hidden', 'xl:block']">
      <!-- 실제 테이블 구조로 변경 -->
      <table class="inspect-table">
        <!-- 테이블 헤더 -->
        <thead>
          <tr class="row-header">
            <th class="row-header__item" :style="`width: calc(100% - ${headerWidthYes} - ${headerWidthNo} - ${headerWidthNa} - ${isNote ? headerWidthNote : '0px'})`">{{getHeaderTitle}}</th>
            <th class="row-header__item" :style="`width: ${headerWidthYes}`">{{getHeaderYes}}</th>
            <th class="row-header__item" :style="`width: ${headerWidthNo}`">{{getHeaderNo}}</th>
            <th class="row-header__item" :style="`width: ${headerWidthNa}; white-space: nowrap;`">{{getHeaderNa}}</th>
            <th v-if="isNote" class="row-header__item" :style="`width: ${headerWidthNote}`">{{getHeaderNote}}</th>
          </tr>
        </thead>

        <!-- 테이블 본문 영역 -->
        <tbody>
          <!-- 빈 데이터 안내 (PC) -->
          <tr v-if="!list || list.length === 0">
            <td :colspan="isNote ? 5 : 4" class="row-content-none-data">
              <p class="text-gray-500">등록된 점검 항목이 없습니다.</p>
            </td>
          </tr>

          <!-- 데이터 행들 -->
          <template v-for="(rows, indexRows) in list">
                        <!-- title 속성이 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
            <tr v-if="rows.title && rows.title !== ''
                  && (indexRows === 0 || list[indexRows].title !== list[indexRows - 1].title)"
                :key="`title-${indexRows}`">
              <td :colspan="isNote ? 5 : 4"
                  :class="['item-title', { 'first-title': isFirstTitleInList(indexRows) }]"
                  :style="`background-color: ${rows.titleColor}`">
                <b>{{rows.title}}</b>
              </td>
            </tr>

            <tr class="row-content__body-item" :key="`row-${indexRows}`">
              <!--      항목 구분-->
              <td v-if="rows.group" class="item-content-with-group" :set="(groupData = rows.group)">
                <div class="group-container">
                  <div v-if="indexRows==0 || (list[indexRows - 1].group != groupData)"
                       class="group-label"
                       style="display: flex;justify-content: center;align-items: center;background-color: #F9F9F9; white-space:pre-line"
                       v-text="rows.group"></div>
                  <div class="group-content">
                    <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
                    <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
                  </div>
                </div>
              </td>
              <!-- 항목 이름  -->
              <td v-else class="item-content">
                <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
                <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
              </td>

              <!-- YES -->
              <td class="item-box">
                <template v-if="isPrint">
                  <div class="item-box-check" v-if="rows.is_checked === 'Yes'" style="text-align: center;  align-self: center;">
                    <vs-icon icon="check" size="small"  ></vs-icon>
                  </div>
                  <div v-else class="item-box-check">
                  </div>
                </template>
                <vs-checkbox
                  v-else
                  class="item-box-check"
                  style="padding-left: 5px;"
                  :disabled="isReadonly"
                  :checked="rows.is_checked === 'Yes'"
                  @change="checkForm($event, rows.id, 'Yes')"
                ></vs-checkbox>
              </td>

              <!-- No -->
              <td class="item-box">
                <template v-if="isPrint">
                  <div class="item-box-check" v-if="rows.is_checked === 'No'" style="text-align: center;  align-self: center;">
                    <vs-icon icon="check" size="small"  ></vs-icon>
                  </div>
                  <div v-else class="item-box-check">
                  </div>
                </template>
                <vs-checkbox
                  v-else
                  class="item-box-check"
                  :disabled="isReadonly"
                  :checked="rows.is_checked === 'No'"
                  style="margin-right: 0;padding-left: 5px;"
                  @change="checkForm($event, rows.id, 'No')"
                ></vs-checkbox>
              </td>

              <!-- N/A -->
              <td class="item-box">
                <template v-if="isPrint">
                  <div class="item-box-check" v-if="rows.is_checked === 'N/A'" style="text-align: center;  align-self: center;">
                    <vs-icon icon="check" size="small"  ></vs-icon>
                  </div>
                  <div v-else class="item-box-check">
                  </div>
                </template>
                <vs-checkbox
                  v-else
                  class="item-box-check"
                  style="padding-left: 5px;"
                  :disabled="isReadonly"
                  :checked="rows.is_checked === 'N/A'"
                  @change="checkForm($event, rows.id, 'N/A')"
                ></vs-checkbox>
              </td>

              <!-- 비고 -->
              <td v-if="isNote" class="item-note">
                <span v-if="isPrint" class="print-input"> {{rows.note}} </span>
                <ml-input v-else class="w-full flex-1" v-model="rows.note" @change="updateRowNote($event, rows.id, rows.note)"  :readonly="isReadonly"/>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div v-if="isBottomNote" class="flex items-center mt-4">
        <div class="label-text mr-4">{{ bottomNoteTitle }}</div>
        <p v-if="isPrint" class="w-full flex-1">{{ bottomNote }}</p>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          :readonly="isReadonly"
          v-model="bottomNote"
          @change="updateBottomNote()"
        />
      </div>

      <!-- footer 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
      <div v-if="footer && footer !== ''" class="row-header__item justify-start">
        <b class="ml-2">{{footer}}</b>
      </div>
    </div>

    <!-- 모바일 레이아웃 -->
    <div class="mobile-layout xl:hidden mt-4" :class="onlyPc ? ['hidden'] : ['block', 'xl:hidden']">
      <!-- 빈 데이터 안내 (모바일) -->
      <div v-if="!list || list.length === 0" class="empty-card">
        <p class="text-center text-gray-500">등록된 점검 항목이 없습니다.</p>
      </div>

      <ul v-else>
        <li v-for="(item, item_i) in list" :key="item_i" class="mobile-card">
          <!-- 제목 표시 -->
          <p v-if="!!item.title" class="card-title mb-3" v-html="item.title"></p>

          <!-- 항목 내용 -->
          <div class="card-content">
            <p class="card-label" v-html="item.label"></p>

            <!-- 체크박스 버튼 그룹 -->
            <div class="btn-container">
              <button
                type="button"
                :class="[item.is_checked === 'Yes' && 'active']"
                :disabled="isReadonly"
                @click="handleMobileCheck(item_i, 'Yes')"
              >
                {{ getHeaderYes }}
              </button>
              <button
                type="button"
                :class="[item.is_checked === 'No' && 'active']"
                :disabled="isReadonly"
                @click="handleMobileCheck(item_i, 'No')"
              >
                {{ getHeaderNo }}
              </button>
              <button
                type="button"
                :class="[item.is_checked === 'N/A' && 'active']"
                :disabled="isReadonly"
                @click="handleMobileCheck(item_i, 'N/A')"
              >
                {{ getHeaderNa }}
              </button>
            </div>

            <!-- 비고 입력 -->
            <ml-input
              v-if="isNote"
              class="w-full mt-3"
              v-model="item.note"
              placeholder="비고"
              :readonly="isReadonly"
              @change="updateRowNote($event, item.id, item.note)"
            />
          </div>
        </li>
      </ul>

      <!-- 모바일용 하단 메모 -->
      <div v-if="isBottomNote" class="mobile-bottom-note mt-4">
        <div class="label-text mb-2">{{ bottomNoteTitle }}</div>
        <p v-if="isPrint" class="w-full">{{ bottomNote }}</p>
        <ml-textarea
          v-else
          class="w-full"
          rows="5"
          :readonly="isReadonly"
          v-model="bottomNote"
          @change="updateBottomNote()"
        />
      </div>
    </div>

  </div>
</template>

<script>
import config from '../../public/config'
import {groupData} from "echarts/lib/util/model";
export default {
  name: 'TableInspect',
  props: {
    isPrint: Boolean,
    isReadonly: Boolean,
    onlyPc: {
      type: Boolean,
      default: false,
    },
    /**
     * 테이블 상단에 동그라미(●) 제목을 표시할지 여부
     */
    isShowTitle: Boolean,
    /**
     * 가장 오른쪽 열에 "비고" 칸을 표시할지 여부
     * 은평 branch 에서는 "비고" 칸이 기본으로 노출된다
     */
    isNote: {
      type: Boolean,
      default: true,
    },
    title: String,
    list: Array,
    tableHeaderTitle: String,
    tableHeaderYes: String,
    tableHeaderNo: String,
    tableHeaderNa: String,
    tableHeaderNote: String,
    headerWidthYes: {
      type: String,
      default: '100px',
    },
    headerWidthNo: {
      type: String,
      default: '100px',
    },
    headerWidthNa: {
      type: String,
      default: '100px',
    },
    headerWidthNote: {
      type: String,
      default: '388px',
    },
    footer: String,
    isNotDotInLabel: Boolean,
    isBottomNote: {
      type: Boolean,
      default: false,
    },
    bottomNoteTitle : {
      type: String,
      default: '기타의견'
    },
    initBottomNote: {
      type: String,
      default: '',
    }
  },
  computed: {
    getHeaderTitle () {
      if (this.tableHeaderTitle) return this.tableHeaderTitle
      else return '점검내용'
    },
    getHeaderYes () {
      if (this.tableHeaderYes) return this.tableHeaderYes
      else {
        return '양호'
      }
    },
    getHeaderNo () {
      if (this.tableHeaderNo) return this.tableHeaderNo
      else {
        return '미흡'
      }
    },
    getHeaderNa () {
      if (this.tableHeaderNa) return this.tableHeaderNa
      else {
        return '해당없음'
      }
    },
    getHeaderNote () {
      if (this.tableHeaderNote) return this.tableHeaderNote
      else return '비고(보완계획)'
    }
  },
  emits: ['update-list-check', 'update-note', 'update-bottom-note'],
  methods: {
    groupData,
    checkForm (value, indexRows, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRows - 1, text)
      } else {
        this.$emit('update-list-check', indexRows - 1, '')
      }
    },

    handleMobileCheck(index, value) {
      if (this.isReadonly) return;

      // 모바일에서 체크박스 클릭 시 emit 발생
      this.$emit('update-list-check', index, value);
    },

    updateRowNote (value, indexRows, text) {
      this.$emit('update-note', indexRows - 1, text)
    },

    updateBottomNote() {
      this.$emit('update-bottom-note', this.bottomNote);
    },

    isFirstTitleInList(currentIndex) {
      // 현재 인덱스 이전에 title이 있는 항목이 있는지 확인
      for (let i = 0; i < currentIndex; i++) {
        if (this.list[i].title && this.list[i].title !== '') {
          return false;
        }
      }
      return true;
    }
  },
  data () {
    return {
      hostname: config.HOST_NAME,
      bottomNote: this.initBottomNote,
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.inspect-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.row-header {
  background-color: $bg;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-right: none;
  padding: 10px;
  text-align: center;
  vertical-align: middle;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: $border;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
/* 타이틀 스타일 - 독립적으로 정의 */
.item-title {
  padding: 10px;
  font-weight: bold;
  border: $border !important;
  border-top: none !important;
  border-right: $border !important;

  &.first-title {
    border-top: $border !important;
  }
}

.row-content__body-item {
  td {
    border: $border;
    border-top: none;
    border-right: none;
    vertical-align: middle;
  }

  td:last-child {
    border-right: $border;
  }

  .item-content {
    padding: 10px;
    color: #3c3c3c;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }

    .row-title {
      font-weight: 500;
      display: inline-flex;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }

    .row-title-nodot {
      font-weight: 500;
      display: inline-flex;
    }
  }

  .item-content-with-group {
    padding: 0;

    .group-container {
      display: flex;
      height: 100%;

      .group-label {
        width: 100px;
        border-right: $border;
        padding: 10px 5px;
        min-height: 100%;
      }

      .group-content {
        flex: 1;
        padding: 10px;
        color: #3c3c3c;
      }
    }
  }

  .item-box {
    text-align: center;
    padding: 5px;

    .item-box-check {
      display: flex;
      justify-content: center !important;
      align-items: center;
    }
  }

  .item-note {
    padding: 5px;
    text-align: left;
  }
}

/* 테이블 구조에서는 불필요한 스타일 제거됨 */
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  text-align: center;
  vertical-align: middle;
  border: $border;
  border-top: none;
}

/* 모바일 레이아웃 스타일 */
.mobile-layout {
  .empty-card {
    border: 1px solid #cdcdcd;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    background-color: #f9f9f9;
  }

  ul {
    li.mobile-card {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #cdcdcd;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .card-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 23px;
        color: #2c2c2c;
      }

      .card-content {
        .card-label {
          font-weight: 500;
          color: #3c3c3c;
          margin-bottom: 16px;
        }

        .btn-container {
          display: flex;
          align-items: center;
          border: 1px solid #cdcdcd;
          border-radius: 8px;
          overflow: hidden;

          button {
            flex: 1;
            font-family: "Noto Sans KR";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #2c2c2c;
            background: none;
            border: 0;
            border-right: 1px solid #cdcdcd;
            outline: 0;
            padding: 12px 8px;
            min-height: 44px; // 터치 친화적 최소 높이
            cursor: pointer;
            transition: all 0.2s ease;

            &:last-child {
              border-right: 0;
            }

            &:hover:not(:disabled) {
              background-color: #f5f5f5;
            }

            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }

            &.active {
              color: white;
              background: #200c63;

              &:hover {
                background: #1a0a52;
              }
            }
          }
        }
      }
    }
  }

  .mobile-bottom-note {
    border: 1px solid #cdcdcd;
    border-radius: 8px;
    padding: 20px;

    .label-text {
      width: auto;
      font-weight: 600;
    }
  }
}

/*체크박스 중앙 정렬을 위함.. scope style 내에서는 적용이 안되서 외부로 뺐음*/
.row-content__body-item .item-box .vs-checkbox {
  margin-right: 0;
}

/* 반응형 클래스 */
@media (max-width: 1279px) {
  .pc-layout {
    display: none !important;
  }

  .mobile-layout {
    display: block !important;
  }
}

@media (min-width: 1280px) {
  .pc-layout {
    display: block !important;
  }

  .mobile-layout {
    display: none !important;
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .pc-layout {
    display: block !important;
  }
  .mobile-layout {
    display: none !important;
  }

  /* 테이블 헤더가 페이지마다 반복되도록 설정 */
  .inspect-table {
    page-break-inside: auto;
  }

  .inspect-table thead {
    display: table-header-group;
  }

  .inspect-table tbody {
    display: table-row-group;
  }

  /* 테이블 행이 페이지 경계에서 분할되지 않도록 방지 */
  .inspect-table tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  /* 제목 행은 다음 행과 함께 유지 */
  .item-title {
    page-break-after: avoid;
    break-after: avoid;
  }

  /* 테이블이 페이지 경계에서 적절히 분할되도록 허용 */
  .inspect-table tbody tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
</style>
